module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/my_print-7682bc72a00bd60a33c14b4b91a22001.png";